import { useEffect, useState } from "react";

// All the components

import Hero from "../components/hero";
//import Counter from "./counter";
import BookCard from "../components/book-card";
import CategorySlider from "../components/category-slider";
import Opinion from "../components/opinion";
import Pagination from "../components/pagination";
import FeaturedSection from "../components/sections/featured-section";
import SearchSection from "../components/sections/search-section";
import Subfooter from "../components/subfooter";
import Testimonial from "../components/testimonial";

function Home() {
  const [categories, setCategories] = useState([]);
  const [bestBooks, setBestBooks] = useState([]);
  const [allBooks, setAllBooks] = useState([]);

  useEffect(() => {
    async function getBestBooksDefault() {
      try {
        const res = await fetch(
          "https://api.nytimes.com/svc/books/v3/lists/full-overview.json?api-key=GaESzDWgFVIjf5U4lLsTKDpm4N6uOI2m"
        );
        const data = await res.json();
        const bestBooksLists = data?.results?.lists || [];

        setCategories(bestBooksLists);

        // Flatten all books
        const allBooks = bestBooksLists.flatMap((list) => list.books);
        setAllBooks(allBooks);

        // Select featured books with unique ISBN-10/ISBN-13
        const seenISBNs = new Set();
        const featuredBooks = [];

        for (const list of bestBooksLists) {
          const book = list.books?.[0];
          const isbn =
            book?.primary_isbn10?.trim() || book?.primary_isbn13?.trim();

          if (isbn && !seenISBNs.has(isbn)) {
            seenISBNs.add(isbn);
            featuredBooks.push(book);
          }

          if (featuredBooks.length === 6) break;
        }

        setBestBooks(featuredBooks);
      } catch (error) {
        console.error("Error fetching default books:", error);
      }
    }

    getBestBooksDefault();
  }, []);

  // ============================================== //
  // Pagination section
  // ============================================== //
  let pageNumberLimit;
  if (window.innerWidth < 400) {
    pageNumberLimit = 4;
  } else if (window.innerWidth > 768) {
    pageNumberLimit = 15;
  } else {
    pageNumberLimit = 5;
  }

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 18;
  const [maxPage, setMaxPage] = useState(pageNumberLimit);
  const [minPage, setMinPage] = useState(0);

  let pages = [];

  for (let i = 1; i <= Math.ceil(allBooks.length / itemsPerPage); i++) {
    pages.push(i);
  }

  const handleClick = (e) => {
    setCurrentPage(Number(e.target.id));
  };

  const renderPageNumbers = pages.map((number) => {
    if (number <= maxPage && number > minPage) {
      return (
        <li
          key={"p" + number}
          id={number}
          onClick={handleClick}
          className={`ab-li ${
            currentPage === number ? "paginition-active" : null
          }`}
        >
          {number}
        </li>
      );
    } else {
      return null;
    }
  });

  const lastItemIndex = currentPage * itemsPerPage;
  const firstItemIndex = lastItemIndex - itemsPerPage;
  const currentItem = allBooks.slice(firstItemIndex, lastItemIndex);

  function UpdateCurrentPage(direction) {
    if (direction === "r") {
      setCurrentPage(currentPage + 1);
    } else if (direction === "l") {
      setCurrentPage(currentPage - 1);
    }
  }

  const handleNextbtn = () => {
    UpdateCurrentPage("r");
    if (currentPage === maxPage && currentPage <= pages.length) {
      setMinPage(currentPage);
      if (currentPage + pageNumberLimit <= pages.length) {
        setMaxPage(maxPage + pageNumberLimit);
      } else {
        setMaxPage(pages.length);
      }
    }
    if (currentPage === pages.length) {
      setCurrentPage(1);
      setMaxPage(pageNumberLimit);
      setMinPage(0);
    }
  };

  const handlePrevbtn = () => {
    if (currentPage === 1) {
      setMaxPage(pages.length);
      setMinPage(pages.length - pageNumberLimit);
      setCurrentPage(pages.length);
    } else {
      UpdateCurrentPage("l");
      if (currentPage === minPage + 1) {
        setMaxPage(minPage);
        if (minPage - pageNumberLimit < 0) {
          setMinPage(0);
        } else {
          setMinPage(minPage - pageNumberLimit);
        }
      }
    }
  };

  let pageIncrementBtn = null;
  if (pages.length > maxPage) {
    pageIncrementBtn = (
      <li className="ab-li three-dot" onClick={handleNextbtn}>
        &hellip;
      </li>
    );
  }

  let pageDecrementBtn = null;
  if (minPage >= 1) {
    pageDecrementBtn = (
      <li className="ab-li three-dot" onClick={handlePrevbtn}>
        &hellip;
      </li>
    );
  }

  // const handleLoadMore = () => {
  //   setItemsPerPage(itemsPerPage + 5);
  // };

  return (
    <>
      <Hero />
      <FeaturedSection categories={categories} initailBooks={bestBooks} />
      <SearchSection />
      <section id="book-list">
        <div className="container book-list">
          <div className="section-heading">
            <h2>All Trending Books</h2>
          </div>
          <CategorySlider list={null}></CategorySlider>
          <div className="book-cards">
            {currentItem.map((item) => (
              <BookCard
                key={
                  item.primary_isbn13
                    ? item.primary_isbn13
                    : item.primary_isbn10
                }
                isbn={
                  item.primary_isbn13
                    ? item.primary_isbn13
                    : item.primary_isbn10
                }
                img={item.book_image}
                author={item.author}
                title={item.title}
                des={item.description}
                buyUrl={item.amazon_product_url}
              />
            ))}
          </div>
          <Pagination
            pageNo={renderPageNumbers}
            inc={pageIncrementBtn}
            dec={pageDecrementBtn}
            prev={handlePrevbtn}
            next={handleNextbtn}
          />
        </div>
      </section>
      <Testimonial></Testimonial>
      <Opinion></Opinion>
      <Subfooter></Subfooter>
    </>
  );
}

export default Home;
